import { offsetShadow, PALETTES, TYPE, type ThemeId } from "@chess/shared";

interface Props {
  themeId: ThemeId;
  onChange: (id: ThemeId) => void;
  compact?: boolean;
}

export function PaletteSwitcher({ themeId, onChange, compact = false }: Props) {
  const current = PALETTES[themeId];
  return (
    <div
      style={{
        display: "inline-flex",
        background: current.card,
        border: `2px solid ${current.border}`,
        boxShadow: offsetShadow(current, 4, 4),
        padding: 4,
        gap: 4,
        transition: "background .25s, border-color .25s, box-shadow .25s",
      }}
    >
      {Object.values(PALETTES).map((p) => {
        const active = p.id === themeId;
        return (
          <button
            key={p.id}
            onClick={() => onChange(p.id)}
            title={p.name}
            style={{
              border: `2px solid ${active ? current.fg : "transparent"}`,
              background: p.bg,
              color: p.fg,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: compact ? 0 : 8,
              fontFamily: TYPE.body,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 0.8,
              fontSize: 11,
              height: compact ? 32 : 36,
              width: compact ? 32 : "auto",
              padding: compact ? 0 : "0 10px 0 6px",
              justifyContent: compact ? "center" : "flex-start",
              position: "relative",
            }}
          >
            <span style={{ display: "inline-flex", gap: 2 }}>
              <span style={{ width: 10, height: 16, background: p.bg, border: `1.5px solid ${p.border}` }} />
              <span style={{ width: 10, height: 16, background: p.accent, border: `1.5px solid ${p.border}` }} />
              <span style={{ width: 10, height: 16, background: p.danger, border: `1.5px solid ${p.border}` }} />
            </span>
            {!compact && <span>{p.name}</span>}
          </button>
        );
      })}
    </div>
  );
}
